/**
 * Client Protected Route
 * Guards /portal/* routes — redirects to /portal/login if not authenticated
 * or if user is not a client role
 */

import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/auth-context'

interface ClientProtectedRouteProps {
  children: React.ReactNode
}

export function ClientProtectedRoute({ children }: ClientProtectedRouteProps) {
  const { isAuthenticated, isClient, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="auth-loading">
        <div className="spinner" />
        <p>Loading...</p>
      </div>
    )
  }

  // Not authenticated — redirect to portal login
  if (!isAuthenticated) {
    return <Navigate to="/portal/login" state={{ from: location }} replace />
  }

  // Authenticated but not a client — redirect to staff dashboard
  if (!isClient) {
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}
